class AdvertInlineAddPageController {

  constructor(AdvertService, LoaderService, AlertService, $state, SocialCategoryService) {
    this.AdvertService = AdvertService;
    this.LoaderService = LoaderService;
    this.AlertService = AlertService;
    this.SocialCategoryService = SocialCategoryService;
    this.$state = $state;
  }

  $onInit() {
    var self = this;
    self.files = [];
    self.advert = self.AdvertService.getNew();
    self.advert.type = 2; // set as Inline Advert
    self.SocialCategoryService.getCategories()
        .then( (categories) => self.socialMediaCategories = categories )
        .catch( (error) => self.AlertService.error('Error getting social feed categories') );
  }

  storeFile(picFile) {
    this.files.push(picFile);
  }

  save() {
    var self = this;

    if(self.files[0] !== undefined){
      self.LoaderService.start();
      self.AdvertService.addNew(self.advert, self.files[0])
          .then(() => {
                self.AlertService.success("Advert has been updated");
                self.$state.go('app.advertising.inline');
              }
          )
          .catch((error) => {
            self.AlertService.error("There was a problem saving the Advert")
          })
          .finally(()=> {
            // empty the file array
            self.files.splice(0, self.files.length);

            self.LoaderService.stop();
          });
    }
    else{
      self.AlertService.error("You need to include an image");
    }

  }
}
AdvertInlineAddPageController.$inject = ['AdvertService', 'LoaderService', 'AlertService', '$state', 'SocialCategoryService'];
export default AdvertInlineAddPageController;
